import { Form } from '@ih/app/shared/apis/interfaces';

export class DeleteFormSuccessEffect {
  public static readonly type = '[Project/Forms/List] DeleteFormSuccessEffect';
  constructor(public readonly form: Form | null | undefined) {}
}
